export const getEmptyPreferredTracks = () => ({
    textTrackLang: undefined,
    audioTrackLang: undefined,
    videoTrackLabel: undefined,
});
